import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SearchLimitNotificationService {
    /**
     * initially `false`, because if the type-designation-result-page is shown, then the tab `Spare parts lists`
     * is shown by default. On this tab, the limitLimitNotification should not be shown.
     */
    private visible = new BehaviorSubject<boolean>(false);

    public setVisibility(visible: boolean) {
        this.visible.next(visible);
    }

    public getVisibility() {
        return this.visible.asObservable();
    }
}
